export default {
  nav: {
    home: '首页',
    equipment: '设备',
    equipmentSingle: '单束多丝设备',
    equipmentSingleDesc: '高精度金属3D打印',
    equipmentMulti: '多束并行设备',
    equipmentMultiDesc: '效率提升5倍以上',
    equipmentTitanium: '海绵钛设备',
    equipmentTitaniumDesc: '低成本钛合金打印',
    services: '服务',
    lattice: '点阵结构',
    latticeDesc: '70%重量减轻',
    concrete: '钢板点阵混凝土',
    concreteDesc: '3倍强度提升',
    titaniumAlloy: '极低成本钛合金',
    titaniumAlloyDesc: '50%成本降低',
    solutions: '解决方案',
    ship: '船舶轻量化',
    shipDesc: '减重70%',
    platform: '海洋浮式平台',
    platformDesc: '成本降低50%',
    deepSea: '深海耐压壳体',
    deepSeaDesc: '6000米深度',
    news: '资讯',
    about: '关于',
    quote: '获取报价',
    menu: '菜单'
  },
  footer: {
    desc: '领先的金属增材制造解决方案提供商，致力于为海洋工程提供创新的轻量化技术。',
    wechat: '微信',
    weibo: '微博',
    qrPending: '二维码待上传（请到后台 关于管理-公司信息 上传）',
    xiaohongshu: '小红书',
    products: '产品服务',
    solutions: '解决方案',
    about: '关于我们',
    intro: '公司简介',
    news: '新闻资讯',
    contact: '联系我们',
    join: '加入我们',
    contactTitle: '联系方式',
    address: '📍 广东省深圳市南山区科技园',
    phone: '📞 400-888-8888',
    email: "📧 info{'@'}megamaker.com.cn",
    hours: '🕐 工作日 9:00-18:00',
    copyright: '© 2026 MegaMaker 巨型智造. 保留所有权利.',
    privacy: '隐私政策',
    terms: '使用条款',
    sitemap: '网站地图',
    mapPending: '地图地址未配置，请联系管理员在后台「系统配置」中填写',
    gotIt: '知道了'
  },
  legal: {
    privacy: [
      '我们重视并保护您的个人隐私。本隐私政策说明巨型智造网站（以下简称"本网站"）如何收集、使用、存储和保护您的个人信息。',
      '一、信息收集：您主动提交的信息（如通过在线咨询表单填写的姓名、电话、邮箱、公司名称及咨询内容）；您使用本网站时的浏览记录、IP 地址、设备信息及 Cookie 数据。',
      '二、信息使用：用于响应您的咨询与需求、改进网站内容与产品服务、发送您主动索取的业务资料，以及法律要求或授权的其他用途。',
      '三、信息共享：我们不会向任何第三方出售或出租您的个人信息。仅在以下情形可能披露：获得您的明确同意、法律法规或政府机关要求、为履行与您之间的服务所必需（如委托的物流、技术服务方，均签署保密协议）。',
      '四、Cookie 与统计：本网站可能使用 Cookie 以改善访问体验，并通过匿名统计了解访问情况。您可通过浏览器设置禁用 Cookie，但不影响基本浏览。',
      '五、数据安全：我们采取合理的技术与管理措施（如加密传输、访问控制）保护您的信息，防止未经授权的访问、泄露或损毁。',
      '六、您的权利：您有权查询、更正、删除您的个人信息，或撤回同意、注销相关记录。如需行使上述权利，请通过网站"联系我们"通道或页尾联系方式与我们取得联系。',
      '七、未成年人保护：本网站主要面向企业客户，不主动收集未成年人个人信息。',
      '八、政策更新：本政策可能适时修订，更新后将在本页面公布。继续使用本网站即视为您接受更新后的政策。'
    ],
    terms: [
      '欢迎访问巨型智造网站。使用本网站前请仔细阅读以下使用条款，访问或使用本网站即表示您同意受本条款约束。',
      '一、网站内容：本网站所载产品、技术、图片、文字、数据等资料均受著作权及相关法律保护，版权归巨型智造或其权利人所有。未经书面许可，不得复制、传播、修改或用于商业用途。',
      '二、使用限制：您不得利用本网站从事任何违法活动，不得试图破坏网站安全、干扰网站正常运行，不得以任何方式侵害他人合法权益。',
      '三、信息准确性：我们尽力保证网站内容准确完整，但不对信息的实时性、完整性作绝对保证。产品参数与性能以双方签署的合同及技术文件为准。',
      '四、免责声明：在法律允许的范围内，对于因使用或依赖本网站信息而导致的任何直接或间接损失，我们不承担赔偿责任。第三方网站链接仅为方便提供，其内容由第三方负责。',
      '五、知识产权侵权投诉：如您认为本网站内容侵犯您的知识产权，请提供权属证明及侵权说明与我们联系，我们将在核实后依法处理。',
      '六、条款变更：我们可能适时修订本条款，修订内容在本页面公布后即生效。',
      '七、法律适用：本条款适用中华人民共和国法律。因本网站产生的争议，双方应友好协商解决；协商不成的，提交公司所在地有管辖权的人民法院诉讼解决。'
    ]
  },
  common: {
    viewDetail: '查看案例',
    learnMore: '了解更多',
    loading: '加载中...'
  },
  inquiry: {
    title: '在线咨询',
    subtitle: '留下您的需求，我们的专家团队将在 1 个工作日内与您联系',
    name: '您的姓名',
    phone: '联系电话',
    company: '公司名称',
    subject: '咨询主题',
    content: '咨询内容',
    submit: '提交咨询',
    submitting: '提交中...',
    success: '提交成功，我们会尽快与您联系',
    fail: '提交失败，请稍后重试'
  },
  video: {
    comingSoon: '视频即将上线'
  },
  maintenance: {
    title: '系统维护中',
    desc: '我们正在对系统进行升级维护，给您带来不便敬请谅解，请稍后再试。',
    tip: '如有紧急需求请联系我们'
  },
  error: {
    title: '数据加载失败',
    desc: '无法获取服务器数据，请检查网络连接或稍后重试',
    retry: '重新加载'
  },
  home: {
    exploreProducts: '探索产品',
    contactUs: '联系我们',
    videoComingSoon: '企业宣传视频即将上线',
    intoTitle: '走进巨型智造',
    intoDesc: '观看我们的智能制造基地，见证金属增材制造装备如何驱动产业升级',
    bookTour: '预约参观',
    coreEquipment: '核心设备',
    equipTitle: '引领行业的3D打印技术',
    learnMoreArrow: '了解详情 →',
    solutions: '解决方案',
    solutionsTitle: '为海洋工程量身定制',
    viewCases: '查看案例 →',
    aboutLabel: '关于我们',
    introTitleLine1: '突破传统制造边界',
    introTitleLine2: '开创海洋工程新纪元',
    introText: '巨型智造专注于大型金属3D打印技术，拥有单束多丝、多束并行、海绵钛等核心专利。我们的技术可实现70%重量减轻、50%成本降低，为海洋工程提供革命性解决方案。',
    mediaBadge: '智能制造基地',
    labAlt: '实验室',
    ctaTitle: '准备好开启您的项目了吗？',
    ctaDesc: '联系我们的专家团队，获取专业的技术咨询和定制化解决方案',
    quote: '获取报价',
    bookConsult: '预约咨询'
  }
,
  eq: {
    title: '核心设备',
    subtitle: '领先的金属3D打印设备技术',
    t1: '单束多丝技术',
    t1n: '单束多丝设备',
    t1f1: '✓ 打印精度：±0.1mm',
    t1f2: '✓ 支持材料：不锈钢、钛合金、铝合金',
    t1f3: '✓ 打印尺寸：500×500×500mm',
    t1f4: '✓ 打印速度：100-200g/h',
    t2: '多束并行技术',
    t2n: '多束并行设备',
    t2f1: '✓ 打印效率：提升5倍以上',
    t2f2: '✓ 最大尺寸：2000×2000×1000mm',
    t2f3: '✓ 激光束数：4-8束可选',
    t2f4: '✓ 同步精度：±0.05mm',
    t3: '海绵钛技术',
    t3n: '海绵钛设备',
    t3f1: '✓ 成本降低：50%以上',
    t3f2: '✓ 耐腐蚀等级：海洋环境适用',
    t3f3: '✓ 材料利用率：95%以上',
    t3f4: '✓ 环保认证：ISO 14001',
  }
,
  svc: {
    title: '3D打印服务',
    subtitle: '专业的金属增材制造解决方案',
    l1: '点阵结构',
    l1b: '70% 重量减轻',
    l1f1: '重量减轻70%以上',
    l1f2: '强度保持率90%',
    l1f3: '材料节省60%',
    l1f4: '定制化设计',
    l2: '钢板点阵混凝土',
    l2b: '3倍 强度提升',
    l2f1: '抗压强度提升3倍',
    l2f2: '耐腐蚀性能优异',
    l2f3: '施工周期缩短50%',
    l2f4: '使用寿命延长',
    l3: '极低成本钛合金',
    l3b: '50% 成本降低',
    l3f1: '成本降低50%',
    l3f2: '性能媲美传统钛合金',
    l3f3: '适用海洋环境',
    l3f4: '快速交付',
  }
,
  sol: {
    title: '解决方案',
    subtitle: '为海洋工程提供创新的轻量化解决方案',
    s1: '船舶轻量化',
    s1b: '减重70%',
    s1f1: '重量减轻70%',
    s1f2: '燃油节省30%',
    s1f3: '载货能力提升',
    s1f4: '耐腐蚀性强',
    s2: '低成本海洋浮式平台',
    s2b: '成本降低50%',
    s2f1: '施工周期缩短',
    s2f2: '抗风浪能力强',
    s2f3: '环保可持续',
    s3: '低成本深海耐压壳体',
    s3b: '6000米深度',
    s3f1: '耐压6000米',
    s3f2: '钛合金材质',
    s3f3: '成本大幅降低',
    s3f4: '定制化设计',
  }
,
  news: {
    learnMore: '了解更多',
    latest: '最新资讯',
    readMore: '阅读全文',
    preview: '新闻预览',
    mediaResource: '媒体资源',
    all: '全部',
    corp: '企业新闻',
    product: '产品资讯',
    exhibition: '展会论坛',
    imageDownload: '图片下载',
    videoDownload: '视频下载',
    m1: '全新超集成激光送丝增材系统L1 Lite',
    m2: '桌面级金属3D打印机Laser Mini',
    m3: '超同轴5000W激光流动关',
    m4: '激光送丝增材技术优势解析',
    m5: '融速科技荣获行业创新奖',
    m6: '中华焊接协会技术交流会',
    defaultCategory: '行业动态',
    backToList: '返回资讯列表',
  }
,
  about: {
    titleLine1: '关于',
    titleLine2: '巨型智造',
    subtitle: '领先的金属增材制造解决方案提供商',
    intro: '公司简介',
    history: '发展历程',
    honors: '资质荣誉',
    contact: '联系我们',
    email: '电子邮箱',
    phone: '联系电话',
    address: '公司地址',
    follow: '关注公众号',
    followDesc: '获取最新产品资讯和技术支持',
    projectNeed: '有项目需求？',
    projectDesc: '留下您的需求，我们的专家团队将在 1 个工作日内与您联系',
    inquiryNow: '立即在线咨询',
    introFallback: '巨型智造，专注于金属增材制造技术的研发与应用。',
  }
,
  eqd: {
    brand: '巨型智造',
    metalAdditive: '金属增材制造',
    viewCount: '累计浏览',
    minLayer: '最小层厚(mm)',
    materials: '支持材料',
    consultNow: '立即咨询',
    moreEquipment: '更多设备',
    priceRange: '价格区间',
    negotiate: '面议',
    onSale: '在售',
    pending: '待咨询',
    coreParams: '核心参数',
    gallery: '设备图集',
    galleryDesc: '多角度了解装备细节',
    demo: '设备演示',
    demoDesc: '观看设备的实际运行表现',
    features: '核心特性',
    featuresDesc: '为高性能金属增材制造而生的技术能力',
    featureDefault: '专业性能保障',
    specs: '技术规格',
    ctaTitle: '准备好用增材制造升级您的项目了吗？',
    ctaDesc: '联系我们的专家团队，获取{name}的详细方案与报价',
    ctaBtn: '立即获取报价',
    videoPlaceholder: '设备演示视频即将上线',
  }
,
  svd: {
    priceInfo: '价格说明',
    quote: '按项目报价',
    standardFlow: '标准流程',
    steps: '个环节',
    proService: '巨型智造 · 专业服务',
    process: '服务环节',
    highlights: '服务亮点',
    viewCount: '累计浏览',
    consultNow: '立即咨询',
    viewCases: '了解案例',
    flowTitle: '服务流程',
    flowDesc: '标准化流程，保障交付质量',
    teamDesc: '专业团队为您保驾护航',
    scenes: '服务场景',
    scenesDesc: '从工艺到成果的全流程展示',
    sceneTags: ['核心工艺', '生产过程', '质量检测'],
    sceneDefault: '服务场景',
    videoTitle: '服务案例视频',
    videoDesc: '真实项目服务过程纪实',
    featureDefault: '专业能力保障',
    detail: '服务详情',
    params: '服务参数',
    ctaTitle: '需要{title}服务？',
    ctaDesc: '联系我们的专家团队，获取专业方案与报价',
    ctaBtn: '立即获取报价',
    videoPlaceholder: '服务案例视频即将上线',
  }
,
  sld: {
    industry: '行业解决方案',
    'advantages': '方案优势',
    advantagesTitle: '方案优势',
    cases: '应用案例',
    viewCount: '累计浏览',
    getSolution: '获取方案',
    learnEquipment: '了解装备',
    online: '方案已上线',
    custom: '定制中',
    pain: '痛点 · 优势',
    painDesc: '直击行业痛点，提供可落地的解决方案',
    painTitle: '行业痛点',
    casesDesc: '方案在实际项目中的落地应用',
    caseTags: ['方案总览', '行业应用', '工程实施'],
    caseDefault: '典型应用场景',
    detail: '方案详情',
    videoTitle: '方案案例视频',
    videoDesc: '了解方案在实际项目中的表现',
    ctaTitle: '想了解{title}如何落地？',
    ctaDesc: '联系我们的方案专家，获取定制化落地建议',
    ctaBtn: '获取专属方案',
    videoPlaceholder: '方案案例视频即将上线',
  }
}
